/**
 * Returns `true` when Hub corner radius customization should be active.
 *
 * Gated by TWO things ANDed together:
 *   1. The product-level flag `advanced-theming-in-hub` (via HubContext —
 *      checked transitively through `useIsAdvancedThemingEnabled`).
 *   2. The new platform-level Statsig gate `hub-corner-radius`.
 *
 * The first comes from `useIsAdvancedThemingEnabled` — corner radius
 * is a sub-feature of advanced theming and never ships without it.
 *
 * Cross-host safe: returns `false` when HubContext is not mounted
 * (Confluence Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled`
 * returns false in that case.
 */
import { fg } from '@atlaskit/platform-feature-flags/fg';

import { useIsAdvancedThemingEnabled } from '../use-is-advanced-theming-enabled';

export const useIsHubCornerRadiusEnabled = (): boolean => {
	const isAdvancedThemingEnabled = useIsAdvancedThemingEnabled();
	return isAdvancedThemingEnabled && fg('hub-corner-radius');
};
